// import React from "react";
import { REACT_APP_DOMAIN_URL } from "features/shared/constants";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { TbCheckupList } from "react-icons/tb";
import { createQueryParams } from "features/config/helpers";
// import { TicketingTriageModal } from "../modals/ticketing-triage.modal";
import { DataList } from "features/shared/presentation/components";
// import { AdminChipsButton } from "features/admin/presentation/components/chips-button";
// import { TICKET_STATUS } from "features/shared/constants";
import {
  useAppDispatch,
  useAppSelector,
  useQuery,
} from "features/config/hooks";
import {
  Column,
  DataTable,
  DataTableCell,
  DataTableRow,
} from "features/shared/presentation/components/data-table";
import {
  getAllTickets,
  resetGetAllTicketsStatus,
  selectGetAllTickets,
} from "../slices/get-all-tickets.slice";
// import { department } from "./ticketing-utils";
// import { getTicket } from "../slices/get-ticket.slice";

// Table Columns
const columns: Array<Column> = [
  { id: "store_name", label: "Name of Store" },
  { id: "from_date", label: "From" },
  { id: "to_date", label: "To" },
  { id: "name_of_file", label: "File Name" },
  { id: "action", label: "Action" },
];

export function AllTicketsContents() {
  const dispatch = useAppDispatch();
  const query = useQuery();
  const navigate = useNavigate();
  const pageNo = query.get("page_no");
  const perPage = query.get("per_page");
  const status = query.get("status");
  const id = query.get("id");
  const orderBy = query.get("order_by");
  const order = query.get("order");
  const search = query.get("search");

  // const [openTriageModal, setOpenTriageModal] = React.useState(false);

  const getAllTicketStates = useAppSelector(selectGetAllTickets);

  // useEffect(() => {
  //   if (id) {
  //     dispatch(getTicket(id)).then(() => {
  //       setOpenTriageModal(true);
  //     });
  //   }
  // }, [dispatch, id]);

  useEffect(() => {
    const query = createQueryParams({
      page_no: pageNo,
      per_page: perPage,
      status: status,
      order_by: orderBy,
      order: order,
      search: search,
    });
    dispatch(getAllTickets(query));
  }, [dispatch, pageNo, status, perPage, orderBy, order, search]);

  return (
    <>
      <div className="flex flex-col lg:flex-row lg:items-end">
        <span className="px-4 text-secondary text-3xl font-['Bebas_Neue'] flex-1">
          List of Sales Variance Reports
        </span>
      </div>

      {getAllTicketStates.data?.tickets ? (
        <>
          {/* Mobile View */}
          <div className="p-4 lg:hidden">
            <DataList
              search={search ?? ""}
              emptyMessage="No data yet."
              onSearch={(val) => {
                const params = {
                  page_no: null,
                  per_page: perPage,
                  status: status,
                  order_by: orderBy,
                  order: order,
                  search: val === "" ? null : val,
                };

                const queryParams = createQueryParams(params);

                navigate({
                  pathname: "",
                  search: queryParams,
                });
              }}
              onRowsPerPageChange={(event) => {
                if (perPage !== event.target.value) {
                  const params = {
                    page_no: pageNo,
                    per_page: event.target.value,
                    status: status,
                    search: search,
                  };

                  const queryParams = createQueryParams(params);

                  dispatch(resetGetAllTicketsStatus());
                  navigate({
                    pathname: "",
                    search: queryParams,
                  });
                }
              }}
              onPageChange={(event, newPage) => {
                const pageNoInt = pageNo ? parseInt(pageNo) : null;
                if (newPage !== pageNoInt) {
                  const params = {
                    page_no: newPage,
                    per_page: perPage,
                    status: status,
                    search: search,
                  };

                  const queryParams = createQueryParams(params);

                  dispatch(resetGetAllTicketsStatus());
                  navigate({
                    pathname: "",
                    search: queryParams,
                  });
                }
              }}
              totalRows={getAllTicketStates.data.pagination.total_rows}
              perPage={getAllTicketStates.data.pagination.per_page}
              page={pageNo ? parseInt(pageNo) : 1}
            >
              <hr className="mt-4" />

              {getAllTicketStates.data.tickets.map((row, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center px-4 py-2 border-b"
                >
                  <div className="flex flex-col">
                    <span className="flex flex-wrap items-center space-x-1 text-xl">
                      <span>{row.store_name}</span>
                    </span>
                    {/* <span className="text-xs text-gray-600">
                      <strong>Ticket Number:</strong> {row.id}
                    </span>
                    <span className="text-xs text-gray-600">
                      <strong>Date Created:</strong> No data on db yet.
                    </span> */}
                  </div>
                  {/* 👇 EDIT THIS 👇 */}
                  {/* <div className="flex items-center">
                    <Link
                      to="/admin/ticketing/view-ticket"
                      style={{ marginRight: "10px" }}
                    >
                      <FaEye className="text-lg" />
                    </Link>
                    <button
                      onClick={() => {
                        const params = {
                          page_no: pageNo,
                          per_page: perPage,
                          status: status,
                          id: row.id,
                          order_by: orderBy,
                          order: order,
                          search: search,
                        };

                        const queryParams = createQueryParams(params);

                        navigate({
                          pathname: "",
                          search: queryParams,
                        });
                      }}
                    >
                      <TbCheckupList className="text-lg" />
                    </button>
                  </div> */}
                </div>
              ))}
            </DataList>
          </div>

          {/* Desktop View */}
          <div className="hidden p-4 lg:block">
            <DataTable
              order={order === "asc" ? "asc" : "desc"}
              orderBy={orderBy ?? "id"}
              emptyMessage="No data yet."
              search={search ?? ""}
              onSearch={(val) => {
                const params = {
                  page_no: pageNo,
                  per_page: perPage,
                  status: status,
                  order_by: orderBy,
                  order: order,
                  search: val === "" ? null : val,
                };

                const queryParams = createQueryParams(params);

                navigate({
                  pathname: "",
                  search: queryParams,
                });
              }}
              onRequestSort={(column_selected) => {
                // if (
                //   column_selected !== "actions" &&
                //   column_selected !== "dateCreated" // 👈 REMOVE THIS LINE, if okay na sa database hehe: 👤 Dale
                // ) {
                //   const isAsc = orderBy === column_selected && order === "asc";
                //   const params = {
                //     page_no: pageNo,
                //     per_page: perPage,
                //     status: status,
                //     order_by: column_selected,
                //     order: isAsc ? "desc" : "asc",
                //     search: search,
                //   };
                //   const queryParams = createQueryParams(params);
                //   dispatch(resetGetAllTicketsStatus());
                //   navigate({
                //     pathname: "",
                //     search: queryParams,
                //   });
                // }
              }}
              columns={columns}
              onRowsPerPageChange={(event) => {
                if (perPage !== event.target.value) {
                  const params = {
                    page_no: pageNo,
                    per_page: event.target.value,
                    status: status,
                    order_by: orderBy,
                    order: order,
                    search: search,
                  };
                  const queryParams = createQueryParams(params);
                  dispatch(resetGetAllTicketsStatus());
                  navigate({
                    pathname: "",
                    search: queryParams,
                  });
                }
              }}
              onPageChange={(event, newPage) => {
                const pageNoInt = pageNo ? parseInt(pageNo) : null;
                if (newPage !== pageNoInt) {
                  const params = {
                    page_no: newPage,
                    per_page: perPage,
                    status: status,
                    order_by: orderBy,
                    order: order,
                    search: search,
                  };

                  const queryParams = createQueryParams(params);

                  dispatch(resetGetAllTicketsStatus());
                  navigate({
                    pathname: "",
                    search: queryParams,
                  });
                }
              }}
              totalRows={getAllTicketStates.data.pagination.total_rows}
              perPage={getAllTicketStates.data.pagination.per_page}
              page={pageNo ? parseInt(pageNo) : 1}
            >
              {getAllTicketStates.data.tickets.map((row, i) => (
                <>
                  <DataTableRow key={i}>
                    <DataTableCell>{row.store_name}</DataTableCell>
                    <DataTableCell>{row.from_date}</DataTableCell>
                    <DataTableCell>{row.to_date}</DataTableCell>
                    <DataTableCell>{row.name_of_file}</DataTableCell>
                    <DataTableCell>
                      <a
                        href={`${REACT_APP_DOMAIN_URL}${row.folder_path}${row.name_of_file}`}
                        className="px-3 py-1 border rounded-lg border-secondary font-['Varela_Round']"
                      >
                        Download
                      </a>
                    </DataTableCell>
                  </DataTableRow>
                </>
              ))}
            </DataTable>
          </div>
        </>
      ) : null}
    </>
  );
}
